import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { Result } from "../../models/Result";
import { fetchData, postData } from '../../services/ApiService';
import {
  closeCircularProgress,
  openCircularProgress,
} from "../uireducers/progress";


// Logic to save template
export const publishResult = createAsyncThunk(
  "resultEntity/publishResult",
  async (data: Result, thunkAPI) => {
      // Open the Circular Progress
      thunkAPI.dispatch(openCircularProgress());

      try {
        const response = await postData(`results`, data); // Specify the type if known
        // Close the Circular Progress
        thunkAPI.dispatch(closeCircularProgress());
        return response; // Return the fetched data
      } catch (error) {
        // Close the Circular Progress
        thunkAPI.dispatch(closeCircularProgress());
        return thunkAPI.rejectWithValue(error); // Handle the error appropriately
      }
  }
);

export const getTodayResults = createAsyncThunk(
  "resultEntity/getTodayResults",
  async (data, thunkAPI) => {
      // Open the Circular Progress
      thunkAPI.dispatch(openCircularProgress());

      try {
        const response = await fetchData(`results/today`); // Specify the type if known
        // Close the Circular Progress
        thunkAPI.dispatch(closeCircularProgress());
        return response; // Return the fetched data
      } catch (error) {
        // Close the Circular Progress
        thunkAPI.dispatch(closeCircularProgress());
        return thunkAPI.rejectWithValue(error); // Handle the error appropriately
      }
  }
);

const slice = createSlice({
  name: "resultEntity",
  initialState: {
    result: {} as Result,
    todayResults: [] as Result[]
  },
  reducers: {
  },
  extraReducers: (builder) => {
    builder.addCase(publishResult.fulfilled, (state, action)=>{
    });

    builder.addCase(getTodayResults.fulfilled, (state, action)=>{
      state.todayResults = action.payload
    });
  },
});

//export const { setSelectedGame } = slice.actions;

export default slice.reducer;